import { Button } from '@mantine/core';
import type React from 'react';
import { Link } from 'react-router-dom';

type NavButtonProps = React.ComponentPropsWithoutRef<typeof Button<typeof Link>> & {
  to: string;
  label: React.ReactNode;
};

export const NavButton = ({ to, label, ...buttonProps }: NavButtonProps) => {
  return (
    <Button w="fit-content" component={Link} to={to} {...buttonProps}>
      {label}
    </Button>
  );
};
